















































































import { Component, Vue } from 'vue-property-decorator'
import firebase from 'firebase/app'

@Component({
  name: 'NewIdea'
})
export default class NewIdea extends Vue {

  title: string = ''
  contentMain: string = ''
  feedback: string = ''
  contentBusinessPoint: string = ''
  contentSocialPoint: string = ''
  contentInnovationPoint1: string = ''
  contentInnovationPoint2: string = ''
  contentInnovationPoint3: string = ''
  uploadedImage: any = { url: '' }
  ImagenamePath: string = ''
  frStorage: firebase.storage.Storage = firebase.storage()
  isLoading: boolean = false
  newIdeas: any[] = []
 
  async onRegist() {
    this.isLoading = true
    await this.writeFirestore()
    this.clear()
    this.isLoading = false
    this.$router.push({ name: 'Home'})
  }
  
  async writeFirestore() {
    try {
      const db: firebase.firestore.Firestore = firebase.firestore()
      const collection: firebase.firestore.CollectionReference = db.collection('ideas')
      const id: string = collection.doc().id
      const result = await collection.doc(id).set({
        title: this.title,
        contentMain: this.contentMain,
        contentSocialPoint: this.contentSocialPoint,
        contentBusinessPoint: this.contentBusinessPoint,
        contentInnovationPoint1: this.contentInnovationPoint1,
        contentInnovationPoint2: this.contentInnovationPoint2,
        contentInnovationPoint3: this.contentInnovationPoint3
      })
    } catch (error) {
      console.log('firebase error', error)
    }
  }

  clear() {
    this.title = ''
    this.contentMain = ''
    this.contentSocialPoint = ''
    this.contentBusinessPoint = ''
    this.contentInnovationPoint1 = ''
    this.contentInnovationPoint2 = ''
    this.contentInnovationPoint3 = ''
    this.uploadedImage = { url: '' }
  }
  
  onFileChange() {
    console.log('onFileChange')
  }

  // async upload () {
  //   try {
  //       let path = this.ImagenamePath
  //       let mountainsRef = this.frStorage.ref().child(path)
  //       await mountainsRef.put(this.uploadedImage)
  //       let url = await mountainsRef.getDownloadURL()
  //       console.log('storage upload', url)
  //       return url
  //   } catch (error) {
  //       throw error
  //   }
  // }
}
